import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import { getIPv6Prefix } from "common/api";
import ListSubscribers from "./ListSubscribers";
import ActionsContext from "common/ActionsContext";
import BqnContext from "common/BqnContext";
import { mergeNodeRows, subscribersRetrieval } from "../api";

const createPlaceholder = () =>
  "ADDRESS         SUBSCRIBER-ID   USER-NAME       CALL-STATION-ID NAS-IDENTIFIER  NAS-IP-ADDRESS  NAS-PORT ACCT-SESS-ID  SOURCE   BLOCK POLICY                    QUOTA                  LIMIT-TIME      LIMIT-VOLUME CREATED              UPDATED\n";

const ensurePlaceholder = (/*error*/) => {
  return { response: createPlaceholder() };
};

const ensureCIDR = (subnet) =>
  Promise.resolve(
    subnet.length === 0 || subnet.includes("/") ? subnet : addCIDR(subnet)
  );

const addCIDR = (subnet) =>
  subnet.includes(":")
    ? /*ipv6*/ getIPv6Prefix().then((prefix) => `${subnet}/${prefix}`)
    : `${subnet}/32`;

const doRequest = ({ policy, subnet, lines, bqns, mode, bqnId }) =>
  ensureCIDR(subnet).then((cidrSubnet) =>
    subscribersRetrieval({ policy, subnet: cidrSubnet, lines, mode, bqnId })
      .then((response) => bqns === null ? response : mergeNodeRows(response, bqns.length))
      .then((response) => ({response}))
      .catch(ensurePlaceholder)
  );

const ResultsLayout = styled.div`
  flex: 100%;
  overflow: hidden; /*list will scroll*/
`;

const Report = ({ policy, subnet, lines, ...otherSettings }) => {
  const { bqnId, bqns, clusterStatus } = useContext(BqnContext);
  const mode = clusterStatus?.mode;
  const [request, setRequest] = useState(null);
  const actions = useContext(ActionsContext);
  // Nothing is asked while the BQN context has not loaded the BQN selected:
  // the command would not carry its option, and the response would be that of
  // the whole cluster. The effect runs again when it does.
  useEffect(() => {
    if (bqnId === undefined) {
      return;
    }

    doLoad();
    return actions.recv("do-load", doLoad);
  }, [policy, subnet, lines, mode, bqnId]);
  const doLoad = () => setRequest(
    doRequest({
      policy,
      subnet,
      lines,
      bqns: bqnId === 'all' ? bqns : null,
      mode,
      bqnId,
    })
  );
  return request === null ? null : (
      <ResultsLayout>
        <ListSubscribers request={request} subnet={subnet} {...otherSettings} />
      </ResultsLayout>
  );
};

export default Report;
